import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  useGlobalSettingsGetAutobasLogin,
  useGlobalSettingsGetAutobasLoginLinkHook,
} from 'api/global-settings/global-settings';
import styled from 'styled-components';

const StyledLink = styled.a`
  text-decoration: none;
`;

/**
 * Visas på raden Kamremsintervall när Ride-datan inte går att lita på. Länken loggar in direkt
 * med Zäkras delade Autobas-konto (Globala inställningar). Användarnamn och lösenord når aldrig
 * webben: inloggningssidan i backend fyller i dem. Utan direktinloggning (inte inställt, ingen
 * behörighet eller länken pekar inte på autobas.se) visas den gamla texten.
 */
const AutobasLoginInfo = () => {
  const { data: login } = useGlobalSettingsGetAutobasLogin();
  const getLoginLink = useGlobalSettingsGetAutobasLoginLinkHook();

  if (!login?.loginUrl) {
    return <>Dubbelkolla i bilen / servicebok</>;
  }

  // Fliken öppnas redan vid klicket, annars stoppar popup-blockeringen den. Biljetten i länken
  // gäller bara i två minuter och hämtas därför först nu. Går den inte att hämta öppnas Autobas
  // vanliga sida.
  const openAutobas = async () => {
    const tab = window.open('', '_blank');
    if (tab) tab.opener = null;

    const link = await getLoginLink().catch(() => undefined);
    const target = link?.path || login.url;
    if (tab) tab.location.href = target;
    else window.open(target, '_blank', 'noopener');
  };

  return (
    <StyledLink
      href={login.url}
      rel="noreferrer"
      target="_blank"
      onClick={(e) => {
        e.preventDefault();
        openAutobas();
      }}
    >
      Kolla i Autobas <FontAwesomeIcon icon={faExternalLink} />
    </StyledLink>
  );
};

export default AutobasLoginInfo;
